module.exports = __webpack_public_path__ + "img/l_ck.d012c562.png";